export const envFlag = process.env.DEPLOYMENT_ENV || 'prod';
export const IS_DEV = envFlag === 'dev'; // 开发环境，tip-devops平台开发环境标识为dev
export const IS_SIT = envFlag === 'sit'; // 测试环境
export const IS_PRE = envFlag === 'pre'; // 预发环境
export const IS_PROD = envFlag === 'prod'; // 线上环境

// 转换预发域名，前缀加了staging-，因此只传递关键域名host，其余host可定制
export const translateStagingDomain = (originDomain = '', originHost = '') => `//staging-${originDomain}${originHost || '.ewt360.com'}`;

// 根据指定的域名前缀生成通用的完整域名
export const makeUnifyDomain = (originDomain, stagingDomain) => {
  let urlHost = `//${originDomain}.ewt360.com`;
  if (IS_SIT) urlHost = `//${originDomain}.test.ewt360.com`;
  if (IS_DEV) urlHost = `//${originDomain}.dev.ewt360.com`;
  if (IS_PRE) urlHost = translateStagingDomain(originDomain, stagingDomain);
  return urlHost;
};

// 域名host生成
export const www = makeUnifyDomain('www');
export const web = makeUnifyDomain('web'); // 静态资源 host
export const gateway = makeUnifyDomain('gateway'); // api-gateway host



// WEBPACK FOOTER //
// ./src/utils/hosts.js